const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/styles.ts';
import { css } from '@emotion/css';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

export const useMobileFormCSS = () => {
    const theme = useTheme();
    return useMemo(
        () => css`
            & > .MobileFormSection,
            & > .MobileFormBlock > .MobileFormSection {
                display: block;
                padding: ${theme.spacing(2)};
                background-color: ${theme.palette.common.white};

                & > .MobileFormSectionHeader {
                    padding: 0;
                    margin: 0;
                }

                & > .MuiAccordion-root,
                & > .MuiAccordion-root.Mui-expanded {
                    margin: 0 !important; // Because other !important

                    & .MobileFormSectionHeader {
                        padding: 0;
                    }

                    & > .MuiAccordionSummary-root {
                        min-height: 24px;

                        & > .MuiAccordionSummary-expandIconWrapper > .MuiIconButton-root {
                            padding: 0;
                        }
                    }
                }
            }

            & .MobileFormSection > .MobileFormSection {
                background-color: transparent;
                padding: 0;
                border-width: 0;
            }

            & .MobileFormBlock {
                display: block;
            }

            & .MobileFormSection,
            & .MobileFormSection > *,
            & .MobileFormBlock,
            & .MobileFormBlock > * {
                margin: ${theme.spacing(2)} 0 0 0;

                &:first-child {
                    margin-top: 0;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .disabled,
            .Mui-disabled {
                opacity: 0.4;

                *,
                .disabled,
                .Mui-disabled {
                    opacity: 1;
                }
            }

            & .MuiAccordion-root .MuiAccordionDetails-root > * {
                margin: ${theme.spacing(2)} 0 0 0;
            }

            & .MobileFormSection > *,
            & .MobileFormBlock > *,
            & .MuiAccordionDetails-root > * {
                padding: 0;
            }

            // MUI
            & .MuiTextField-root > label + .MuiInput-root {
                margin-top: 12px;
            }

            & .MuiCheckbox-root,
            & .MuiRadio-root {
                padding: 2px 5px;
                margin-left: -7px; // slight change of position to left align the circle/square with the surrounding content
            }

            & .MuiFormControlLabel-root {
                margin-left: 0;
            }

            & .MobileFormSection > .DateTimePicker > .MuiFormControl-root {
                margin-bottom: 0;
            }

            & .MobileFormSection .MuiAlert-root .MuiAlert-icon {
                margin-left: ${theme.spacing(1.5)};
            }
        `,
        [theme]
    );
};

export function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            cssFieldHorizontal: css`
                display: flex;
                align-items: center;
                justify-content: space-between;

                &:not(:first-of-type) {
                    margin-top: ${theme.spacing(1)};
                }

                & > p {
                    margin-right: ${theme.spacing(1)};
                }
            `,
            cssFieldVertical: css`
                display: flex;
                flex-direction: column;

                &:not(:first-of-type) {
                    margin-top: ${theme.spacing(1)};
                }
            `,
        }),
        [theme]
    );
}

export const cssInvisible = css`
    display: none !important; // in this case, !important actually plays a valid role
`;

export const cssWoundDocuWithTakeOver = css`
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    > .MobileFormSection:first-child {
        flex: 1 1 auto;
    }
    > .takeOverButton {
        margin: 0;
    }
`;

export const useStomaProtocolFormCSS = () => {
    const theme = useTheme();
    return useMemo(
        () => css`
            & .enferntDatePicker {
                margin-top: 0;
            }

            & .lengthWidth > * {
                ${theme.breakpoints.up('sm')} {
                    margin-top: 0;

                    &:not(:first-of-type) {
                        margin-left: ${theme.spacing(2)};
                    }
                }
                ${theme.breakpoints.down('sm')} {
                    min-width: 45vw;
                }
            }

            > .takeOverWrapper {
                display: flex !important;
                justify-content: space-between;
                align-items: center;

                > .takeOverButton {
                    margin: 0;
                }
                &.hidden {
                    display: none !important;
                }
            }
        `,
        [theme]
    );
};
